export enum DataFlag {
    LOADING = 1,
    NODATA = 2,
    DATA = 3
}